import { useTranslation } from "react-i18next";
import AxiosInstance from "../../../shared/utils/axios";
import { formatTranslation } from "../../../shared/utils/translationUtils";

export interface AgOperationPayload {
  org_id: string;
  property_id: string;
  field_ids: string[];
  trial_types: string[];
}

export interface AgOperationData {
  id: string;
  org_id: string;
  property_id: string;
  field_ids: string[];
  is_exportable: boolean;
}

export interface UseAgOperationsInterface {
  handleAgOperation: (
    data: AgOperationData,
    trialTypes: string[]
  ) => Promise<void>;
}

const useAgOperations = (): UseAgOperationsInterface => {
  const { t } = useTranslation();

  /**
   * `trialTypes` is passed in explicitly by each step rather than always
   * defaulting to the protocol's full selected type list: Basic Info / Plot
   * Design pass the protocol's types as-is (no rates data exists yet to
   * narrow them down), while the Rates & Dosage / Summary steps pass only
   * the seed/biological/nutrient types that actually have data at the time
   * of the call — see `getRatesTrialTypesWithData`.
   */
  const handleAgOperation = async (
    data: AgOperationData,
    trialTypes: string[]
  ): Promise<void> => {
    if (!data?.is_exportable) return;
    try {
      const payload: AgOperationPayload = {
        org_id: data?.org_id,
        property_id: data?.property_id,
        field_ids: data?.field_ids ?? [],
        trial_types: trialTypes,
      };
      await AxiosInstance.post(`/trial/${data?.id}/ag_operation`, payload);
    } catch (err) {
      console.error(
        formatTranslation(t("common.error.console.agOperation")),
        err
      );
    }
  };

  return { handleAgOperation };
};

export default useAgOperations;
